import { render, staticRenderFns } from "./design.vue?vue&type=template&id=4da6a146&scoped=true&"
import script from "./design.vue?vue&type=script&lang=js&"
export * from "./design.vue?vue&type=script&lang=js&"
import style0 from "./design.vue?vue&type=style&index=0&id=4da6a146&prod&lang=css&"
import style1 from "./design.vue?vue&type=style&index=1&id=4da6a146&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da6a146",
  null
  
)

export default component.exports